import React from "react";
import { Link } from "react-router-dom";
import { Megaphone, ArrowRight } from "lucide-react";
import { useLang } from "@/context/LanguageContext";

const SponsorBanner = () => {
  const { t } = useLang();
  return (
    <section className="hac-container">
      <Link
        to="/sponsor"
        data-testid="sponsor-banner"
        className="group block bg-[#0F172A] text-white rounded-2xl overflow-hidden relative hover:bg-[#1E293B] transition-colors"
      >
        <div className="grid md:grid-cols-[1fr_auto] gap-6 items-center p-6 md:p-10">
          <div className="flex items-start gap-4">
            <div className="w-12 h-12 shrink-0 bg-[#2563EB] rounded-full flex items-center justify-center">
              <Megaphone size={22} />
            </div>
            <div>
              <div className="text-[10px] font-semibold uppercase tracking-[0.2em] text-[#60A5FA] mb-2">
                {t.sponsor.nav}
              </div>
              <h3 className="text-xl md:text-3xl font-bold leading-tight mb-2">
                {t.sponsor.bannerTitle}
              </h3>
              <p className="text-sm md:text-base text-white/75 max-w-xl leading-relaxed">
                {t.sponsor.bannerSub}
              </p>
            </div>
          </div>
          <span className="inline-flex items-center gap-2 bg-[#2563EB] text-white font-semibold px-6 py-3 rounded-full self-start md:self-center transition-all group-hover:bg-[#1D4ED8] group-hover:translate-x-1">
            {t.sponsor.cta} <ArrowRight size={16} />
          </span>
        </div>
      </Link>
    </section>
  );
};

export default SponsorBanner;
